import React from 'react';
import { Loader } from '../basic/Loader';

type SplashScreenProps = {
    message: string;
}
export function SplashScreen(props: SplashScreenProps) {
    return  <div className='splash-screen'><Loader></Loader>{props.message}</div>
}
